module.exports = __webpack_public_path__ + "static/media/regulatory_agency.f3bef836.svg";